import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../../lib/api";
import WineCard from "../../components/WineCard";
import { Input } from "../../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Button } from "../../components/ui/button";
import { X } from "lucide-react";

export default function B2BWines() {
  const [params, setParams] = useSearchParams();
  const [wines, setWines] = useState([]);
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState(params.get("country") || "");
  const [color, setColor] = useState("");
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/wines/countries").then(r => setCountries(r.data));
  }, []);

  const load = () => {
    const qs = new URLSearchParams();
    if (country && country !== "all") qs.set("country", country);
    if (color && color !== "all") qs.set("color", color);
    qs.set("limit", "80");
    api.get(`/wines?${qs.toString()}`).then(r => setWines(r.data));
  };
  useEffect(load, [country, color]);

  useEffect(() => {
    if (country) setParams({ country });
    else setParams({});
    // eslint-disable-next-line
  }, [country]);

  const filtered = wines.filter(w => !q || w.name.toLowerCase().includes(q.toLowerCase()) || w.winery.toLowerCase().includes(q.toLowerCase()) || w.grape.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="b2b-wines-page" className="container-xl py-10">
      <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--accent))] mb-2">Catalogo professionale · worldwide</div>
      <h1 className="editorial-heading text-5xl md:text-6xl text-[hsl(var(--foreground))] leading-none">Vini da tutto il mondo</h1>
      <p className="text-[hsl(var(--muted-foreground))] mt-3 max-w-2xl">Prezzi per bottiglia, cartone e pallet. Stock in tempo reale. Certificazioni DOC/DOCG/AOC/DOCa/AVA.</p>

      {/* Country chips */}
      <div className="mt-6 flex flex-wrap gap-2">
        <Button
          data-testid="country-chip-all"
          variant={!country ? "default" : "outline"}
          onClick={() => setCountry("")}
          size="sm"
          className={`rounded-full ${!country ? "bg-[hsl(var(--accent))] text-black" : "border-[hsl(var(--border))] text-[hsl(var(--foreground))]"}`}
        >Tutti i paesi</Button>
        {countries.map(c => (
          <Button
            key={c.country}
            data-testid={`country-chip-${c.country}`}
            variant={country === c.country ? "default" : "outline"}
            onClick={() => setCountry(c.country)}
            size="sm"
            className={`rounded-full gap-2 ${country === c.country ? "bg-[hsl(var(--accent))] text-black" : "border-[hsl(var(--border))] text-[hsl(var(--foreground))]"}`}
          >
            {c.country} <span className="text-[10px] opacity-70">{c.count}</span>
          </Button>
        ))}
      </div>

      <div className="mt-6 flex flex-wrap gap-3">
        <Input
          data-testid="wines-search"
          placeholder="Cerca per nome, cantina, vitigno…"
          value={q}
          onChange={e => setQ(e.target.value)}
          className="max-w-sm bg-[hsl(var(--card))] border-[hsl(var(--border))]"
        />
        <Select value={color} onValueChange={setColor}>
          <SelectTrigger data-testid="wines-filter-color" className="w-[160px] bg-[hsl(var(--card))] border-[hsl(var(--border))]"><SelectValue placeholder="Colore" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tutti i colori</SelectItem>
            <SelectItem value="Rosso">Rosso</SelectItem>
            <SelectItem value="Bianco">Bianco</SelectItem>
            <SelectItem value="Rosato">Rosato</SelectItem>
            <SelectItem value="Spumante">Spumante</SelectItem>
          </SelectContent>
        </Select>
        {(country || color) && (
          <Button data-testid="wines-clear-filters" variant="ghost" size="sm" onClick={() => { setCountry(""); setColor(""); }} className="gap-1 text-[hsl(var(--muted-foreground))]">
            <X className="h-3 w-3" />Reset filtri
          </Button>
        )}
      </div>

      <div className="mt-4 text-sm text-[hsl(var(--muted-foreground))]">{filtered.length} etichette</div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        {filtered.map(w => <WineCard key={w.id} wine={w} />)}
      </div>
      {filtered.length === 0 && <div className="mt-12 text-center text-[hsl(var(--muted-foreground))]">Nessun vino trovato</div>}
    </div>
  );
}
